import { render, staticRenderFns } from "./EntryPoint.vue?vue&type=template&id=7c77427f&"
var script = {}
import style0 from "./EntryPoint.vue?vue&type=style&index=0&id=7c77427f&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports